import React, { FC } from 'react';
import { AdvancedFilters } from '../../advanced_filters/AdvancedFilters';
import { WORK_ORDER_SORTERS } from '../config/sorters/sorters';

interface FiltersProps {
	filters: any;
	applyFilters: any;
	clearFilters: any;
	targetCollectionName: String;
	filterConfig: any;
	userType: any;
	sorters: any;
	applySorting: any;
	preAppliedFilters: any;
	currentUser: any;
	/** Defaulted to `WORK_ORDER_SORTERS` below, so a caller need not pass it. */
	sorterItems?: any;
	filterPlaceHolder?: string;
}

const Filters: FC<FiltersProps> = ({
	preAppliedFilters,
	filters,
	applyFilters,
	applySorting,
	clearFilters,
	targetCollectionName,
	filterConfig,
	sorters,
	sorterItems = WORK_ORDER_SORTERS,
	filterPlaceHolder,
}): React.ReactElement => {
	return (
		<AdvancedFilters
			updateFilters={applyFilters}
			filterConfig={filterConfig}
			filtersTargetCollectionName={targetCollectionName}
			clearAndUpdateFilters={clearFilters}
			initialFilters={filters}
			filtersStateSlice={filters}
			applySorting={applySorting}
			sorters={sorters}
			sorterItems={sorterItems}
			preAppliedFilters={preAppliedFilters}
			filterPlaceHolder={filterPlaceHolder}
		/>
	);
};

export default Filters;
